import { useEffect } from "react";

// Lightweight per-page SEO: title, meta description, OG tags, optional JSON-LD.
export default function Seo({ title, description, image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");

    let ld = document.getElementById("yaza-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "yaza-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    }
    return () => {
      if (ld && jsonLd) ld.textContent = "";
    };
  }, [title, description, image, jsonLd]);

  return null;
}
